/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {verifyIdentity} from '../api'

export const useMutationVerifyIdentity = createReactQueryMutationHook('verifyIdentity', verifyIdentity)
